import { ThemeProvider } from '@emotion/react'
import { Box, Button, Container, IconButton } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import * as React from 'react'
import theme from '../theme'
import api from '../services/api'
import AddIcon from '@mui/icons-material/Add';
import FormDialog from './FormDialog'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../auth/AuthProvider'
import { useNavigate } from 'react-router-dom'

export default function () {
    const navigate = useNavigate()
    const [handlerDialog, setHandlerDialog] = React.useState(false)
    const [update, setUpdate] = React.useState(false)
    const [id, setId] = React.useState()
    const auth = useAuth()
    React.useEffect(() => {
        setUpdate(false)
        updateData()

    }, [handlerDialog, update])
    React.useEffect(()=>{
        document.title = "Horus - Usuários"
      },[])

    const [data, setData] = React.useState()
    const columns = [
        {
            name: 'id',
            label: 'Id',

        },
        {
            name: 'username',
            label: "Usuário",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: 'role_description',
            label: "Cargo",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: 'active',
            label: "Estado",
            options: {
                customBodyRender: value => <span>{value ? "Ativo" : 'Inativo'}</span>,
                filter: false,
                sort: true,
            }
        },
        {
            name: "actions",
            label: "Ações",
            options: {
                customBodyRenderLite: (dataIndex, rowIndex) =>
                    <>
                        <Button disabled={!auth.hasPerm('user.edit')} sx={{ color: theme.palette.text.primary }} onClick={() => {
                            const id = data[dataIndex].id
                            setId(id)
                            setHandlerDialog(true)
                        }}>
                            <EditIcon />
                        </Button>
                        <Button disabled={!auth.hasPerm('user.delete')} sx={{ color: theme.palette.text.primary }} onClick={() => {
                            const id = data[dataIndex].id
                            const name = data[dataIndex].username
                            deleteItem(id, name)

                        }}>
                            <DeleteIcon />
                        </Button>
                    </>

            }
        }
    ]
    const deleteItem = (id, name) => {
        const conf = confirm(`Deseja realmente apagar o(a): ${name}`)
        if (!conf) return
        api.delete(`user/delete/${id}/`).then(() => {
            setUpdate(true)
        }).catch(err => alert('Algum erro aconteceu...'))
    }
    const updateData = () => {
        api.get('user/all')
            .then(res => {
                setData(res.data)
            }).catch((err) => {
                if (err.response.status == 401) {
                    navigate('/401')
                }
                setData()
            })
    }
    const showFormDialog = () => {
        setId()
        setHandlerDialog(true)
    }
    const options = {
        filterType: 'checkbox',
        rowsPerPageOptions: [30, 50, 100, 500],
        rowsPerPage: 30,
        rowHover: false,
        print: false,
        selectableRows: 'none',
        download: false,
        customToolbar: () => <IconButton onClick={showFormDialog} disabled={!auth.hasPerm('user.create')} sx={{ color: theme.palette.text.primary }}><AddIcon /></IconButton>,
        customToolbarSelect: () => { },
    }
    return (
        <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
            <ThemeProvider theme={theme}>
                <FormDialog open={handlerDialog} id={id} handlerClose={() => setHandlerDialog(false)} updateData={updateData} />
                <Box sm={12} lg={10}>
                    <MUIDataTable
                        title={"Usuários"}
                        data={data}
                        columns={columns}
                        options={options}
                    />
                </Box>
            </ThemeProvider>
        </Container>
    )
}